export enum ClearOrderType {
  all = "all",
  failed = "failed",
}
